import React, { Component } from 'react'
import { Spin } from 'antd'
import { request } from '../utils/http'
import custom from '../config/custom'

export default (WrappedComponent) => {

    return class extends Component {

        constructor(props) {
            super(props)

            this.state = {
                loading: false,
                values: {}
            }
        }

        componentDidMount() {
            this.getValues()
        }

        componentDidUpdate(prevProps) {
            if (this.props.id !== prevProps.id) {
                this.getValues()
            }
        }

        getUrl() {
            return `${custom.baseUrl}/${this.props.model}/${this.props.id || ''}`
        }
        getValues() {
            if (this.props.id) {
                this.setState({ loading: true }, () => {

                    if (this.props.record) {
                        this.setState({ values: this.props.record, loading: false })
                    }
                    else {
                        request(this.getUrl())
                            .then(response => {
                                this.setState({ values: response.data, loading: false })
                            })
                            .catch(() => {

                            })
                            .then(() => {
                                this.setState({ loading: false })
                            })
                    }
                })
            }
        }

        render() {
            return (
                <Spin spinning={this.state.loading}>
                    <WrappedComponent values={this.state.values} {...this.props} />
                </Spin>
            )
        }

    }

}



// WEBPACK FOOTER //
// ./src/hocs/withValues.js